
import UpdateMember from "../../../components/@users/members/UpdateMember";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProfilePage() {

    // return UpdateMember({
    //     routeType: routeTypes.member,
    //     isOwnProfile: true
    // })

    return (
        <UpdateMember 
            routeType={routeTypes.member}
            isOwnProfile={Boolean(true)}
        />
    )
}       